<template>
  <div v-if="isAdmin" class="main" :style="{ overflow: overflow }">
    <div
      v-bind:style="{ height: '100px', 'background-color': '#fff' }"
    ></div>
    <HeaderComponent
      :text="'Admin'"
      backgroundColor="#fff"
    />
    <Transition appear name="fade">
        <div class="menu-container">
            <b-tabs justified pills content-class="mt-3" style="color: #000;">
                <b-tab :title="$t('text.bookings')" :active="activeTab==0" @click="changeTab('bookings')">
                    <BookingAdminComponent style="margin-top: 40px;"/>
                </b-tab>
                <b-tab :title="$t('text.users')" :active="activeTab==1" @click="changeTab('users')">
                    <UserAdminComponent style="margin-top: 40px;" />
                </b-tab>
                <b-tab :title="$t('text.prices')" :active="activeTab==2" @click="changeTab('prices')">
                    <PriceAdminComponent style="margin-top: 40px;" />
                </b-tab>
                <b-tab :title="$t('text.income')" :active="activeTab==3" @click="changeTab('income')">
                    <IncomeAdminComponent style="margin-top: 40px;" />
                </b-tab>
            </b-tabs>
        </div>
    </Transition>
  </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent.vue";
import BookingAdminComponent from "../components/BookingAdminComponent.vue";
import UserAdminComponent from "../components/UserAdminComponent.vue";
import PriceAdminComponent from "../components/PriceAdminComponent.vue";
import IncomeAdminComponent from "../components/IncomeAdminComponent.vue";

export default {
    name: "AdminPage",
    components: {
        HeaderComponent,
        BookingAdminComponent,
        UserAdminComponent,
        PriceAdminComponent,
        IncomeAdminComponent
    },
    data() {
        return {
        overflow: "visible",
        section: 0,
        loading: false,
        bookings: []
        };
    },
    computed: {
        isLoggedIn() {
            return (
                this.$store.getters.token_valid &&
                this.$store.getters.isLoggedIn
            );
        },
        isAdmin() {
            return (
                this.isLoggedIn &&
                this.$store.getters.user.clearance > 2
            );
        },
        activeTab() {
            switch (this.$route.params.tab) {
                case 'bookings':
                    return 0;
                case 'users':
                    return 1;
                case 'prices':
                    return 2;
                case 'income':
                    return 3;
                default: 
                    return 0;
            }
        }
    },
    methods: {
        changeTab(to) {
            if (this.$route.params.tab == to) { return }
            this.$router.push('/admin/' + to)
        }
    },
    mounted() {
        if (!(this.$store.getters.token_valid && this.$store.getters.isLoggedIn)) {
            this.$router.push({ name: 'login', query: { redirect: this.$router.currentRoute } });
        }
    }
};
</script>

<style>
.main {
  height: 100%;
  background-color: #fff;
}

.menu-container {
    max-width: 1200px;
    margin:auto;
    padding-right: 16px;
    padding-left: 16px;
}

.nav-link {
    color: #495057;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  background-color: #111;
}
.nav-link {
  color: #111;
}
.nav-link:hover {
  color: #999;
}
.page-item.active .page-link {
  background-color: #111;
  border-color: #111;
}
.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #000;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>
